import React from 'react';
import { ReactComponent as EmergeLogo } from '@/assets/EmergeLogo_Large.svg';

const ErrorFallback: React.FC = () => {
  return (
    <div className="max-w-dvw max-h-dvh h-dvh w-dvw flex flex-col justify-center items-center gap-y-4 background-dark-emerge">
      <div>
        <EmergeLogo />
      </div>
      <div className="flex flex-col justify-center items-center gap-y-4">
        <div>
          <h1 className="w-full text-center justify-center flex flex-col text-emerge-gradient text-[48px] font-semibold leading-[54px] break-words">
            500
          </h1>
          <p className="text-white text-base font-normal leading-[22px] text-center break-words">
            Something went wrong. Please refresh page.
          </p>
        </div>
        <div>
          <button
            onClick={() => window.location.reload()}
            className="min-w-[100px] px-3 py-2 bg-emerge-teal rounded-[30px] border-none cursor-pointer inline-flex justify-center items-center gap-4 overflow-hidden">
            <span className="text-emerge-navy text-xs font-medium break-words">Refresh</span>
          </button>
        </div>
      </div>
    </div>
  );
};

export default ErrorFallback;
